"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultExecutiveHeaderSection = exports.defaultPropertyAgentHeaderSection = void 0;
exports.defaultPropertyAgentHeaderSection = {
    translate: {
        content: 'Our real estate professionals are what make OKAY.com great, and our diverse and growing team includes a wide range of backgrounds, language capabilities, and district expertise.  But we all share the same passion - to help you find the right property and make the most informed decision.  Come meet our people.',
        title: 'Our Team - Property Agents',
        header: 'Our Property Agents'
    }
};
exports.defaultExecutiveHeaderSection = {
    translate: {
        content: 'Comprised of people with diverse backgrounds in real estate, technology, finance and marketing, the Executive Team at OKAY.com is redefining the real estate experience for agents and clients. We have one goal - to make the experience of finding or marketing a property better for everyone through information transparency, technology, service and leadership.',
        title: 'Our Team - Executive Team',
        header: 'Our Executive Team'
    }
};
